/**
 * Synchronize region pickers between header and footer
 */
document.addEventListener('DOMContentLoaded', function() {
  // Listen for localization form submissions
  const localizationForms = document.querySelectorAll('form[action="/localization"]');
  
  localizationForms.forEach(form => {
    // Store original submit handler
    const originalSubmit = form.submit;
    
    // Override submit to sync all forms
    form.submit = function() {
      // Get the country code from this form
      const countryInput = this.querySelector('input[name="country_code"]');
      if (countryInput) {
        const selectedCountry = countryInput.value;
        
        // Update all other forms with the same country
        localizationForms.forEach(otherForm => {
          if (otherForm !== form) {
            const otherCountryInput = otherForm.querySelector('input[name="country_code"]');
            if (otherCountryInput) {
              otherCountryInput.value = selectedCountry;
            }
          }
        });
      }
      
      // Call original submit
      originalSubmit.call(this);
    };
  });
});